import React from "react";
import { CloseIco } from "../../assets/customIcons";
import styles from "./IMessage.module.scss";

export interface IMessageProps {
  title: string;
  details?: Record<string, Array<string>> | Array<string>;
}

const closeModal = (e) => {
  const parent =
    e.currentTarget?.parentNode?.parentNode?.parentNode?.parentNode;
  if (parent) {
    parent.style.visibility = "hidden";
    parent.style.opacity = "0";
  }
};

export const IMessage: React.FC<IMessageProps> = ({ title, details = {} }) => {
  return (
    <div className={styles.Message} onClick={closeModal}>
      <div className={styles.Message__header}>
        <h3>{title}</h3>
        <CloseIco className={styles.Message__close} />
      </div>
      {details && (
        <ul>
          {Object.values(details).map((detail, dKey) =>
            typeof detail === "string" ? (
              <li key={dKey}>{detail}</li>
            ) : (
              detail?.map((item, key) => <li key={key}>{item}</li>)
            ),
          )}
        </ul>
      )}
    </div>
  );
};
